<template>
  <div class="page-list">
    <!-- 头部开始 -->
    <div class="header">
      <a-row type="flex">
        <a-col :span="4" align="center">
          <a-icon :type="collapsed ? 'menu-unfold' : 'menu-fold'" @click="handleCollapsed" />
        </a-col>
        <a-col :span="16" align="center" class="title">{{ title }}</a-col>
        <a-col :span="4" align="center"></a-col>
      </a-row>
    </div>
    <!-- 头部结束 -->
    <!-- main开始 -->
    <div class="main-container">
      <div class="view-list-wrapper" v-if="pageList.length">
        <div class="list-one" v-for="item in pageList" :key="item.iid">
          <div class="list-title" @click="handleToggle('page', item.pageId, item.pageName)">{{ item.pageName }}</div>
        </div>
      </div>
      <div class="view-list-wrapper" v-else>
        <div style="margin-top: 50%;">
          <a-empty description="当前主题暂无可切换的页面" />
        </div>
      </div>
    </div>
    <!-- main结束 -->
    <a-drawer
      title="主题列表"
      placement="left"
      width="100%"
      :bodyStyle="{
        padding: '0',
        backgroundColor: '#f5f5f5',
        minHeight: 'calc(100vh - 55px)'
      }"
      :visible="this.collapsed"
      @close="handleCollapsed"
    >
      <div class="view-list-wrapper" v-if="themeList.length">
        <div class="list-one" v-for="item in themeList" :key="item.iid">
          <div class="list-title" @click="handleToggle('theme', item.iid, item.themName)">{{ item.themName }}</div>
        </div>
      </div>
      <div class="view-list-wrapper" v-else>
        <div style="margin-top: 50%;">
          <a-empty description="当前暂无可切换的主题列表" />
        </div>
      </div>
    </a-drawer>
    <a-modal
      :visible="visible"
      title="切换演示页面"
      okText="确认"
      cancelText="取消"
      @cancel="handleModalCancel"
      @ok="handleOk"
      centered
    >
      <a-form-model :model="form" ref="form">
        <a-form-model-item
          label="当前页面切换为"
          :rules="{
            required: true,
            message: '请选择用来替换的页面',
            trigger: 'change'
          }"
          prop="pageId"
        >
          <a-select v-model="form.pageId" placeholder="请选择替换的页面">
            <a-select-option v-for="item in transferPageList" :key="item.pageId" :value="item.pageId">{{
              item.pageName
            }}</a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { JDATA_API } from '@/api'
import Socket from '@/utils/socket'
export default {
  name: 'ShowPageList',
  data() {
    return {
      form: {},
      title: '大数据量化分析',
      changeId: '',
      visible: false,
      collapsed: false,
      themeList: [],
      pageList: []
    }
  },
  computed: {
    transferPageList() {
      return this.pageList.filter(item => item.pageId !== this.changeId)
    }
  },
  watch: {},
  mounted() {},
  beforeCreate() {
    JDATA_API.getHost()
      .then(res => {
        if (res.success && res?.data?.contextPath) {
          Socket.init({ host: res.data.contextPath, userId: 'list' }, () => {})
        }
      })
      .catch(err => {
        console.log('err: ', err)
      })
  },
  created() {
    // this.getThemeList()
    // const pageThemId = this.themeList?.[0]?.iid
    // this.getPageList(pageThemId)
    const _this = this
    JDATA_API.getThemList()
      .then(res => {
        const pageThemId = res?.data?.list?.[0]?.iid
        _this.title = res?.data?.list?.[0]?.themName || '大数据量化分析'
        JDATA_API.getPageList({ pageThemId }).then(response => {
          _this.pageList = response?.data?.list ?? []
        })
      })
      .catch(err => {
        console.log('err: ', err)
      })
  },
  methods: {
    // 获取主题列表
    async getThemeList() {
      try {
        const res = await JDATA_API.getThemList()
        if (res.success) {
          this.themeList = res?.data?.list ?? []
        }
      } catch (err) {
        console.log('err: ', err)
      }
    },
    async getPageList(pageThemId) {
      try {
        const res = await JDATA_API.getPageList({ pageThemId })
        if (res.success) {
          this.pageList = res?.data?.list ?? []
        }
      } catch (err) {
        console.log('err: ', err)
      }
    },
    // 获取页面列表
    // 隐藏与展开显示面板
    handleCollapsed() {
      if (!this.collapsed) {
        this.getThemeList()
      }
      this.collapsed = !this.collapsed
    },
    // 关闭开启面板
    handleChoose() {
      this.collapsed = false
    },
    // 切换按钮
    handleToggle(type, iid, name) {
      if (type === 'theme') {
        this.getPageList(iid)
        this.collapsed = false
        this.title = name
      }
      if (type === 'page') {
        this.changeId = iid
        if (this.transferPageList.length) {
          this.visible = true
        } else {
          this.$message.warning({
            content: '当前主题暂无可供切换的列表',
            key: 'warning'
          })
        }
      }
    },
    // 按钮取消
    handleModalCancel() {
      this.visible = false
      this.form = {}
    },
    // 按钮确定
    handleOk() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const data = { oldPageId: this.changeId, newPageId: this.form.pageId }
          Socket.send(data)
          this.visible = false
          this.form = {}
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
// 头部样式
.header {
  height: 60px;
  line-height: 60px;
  .title {
    font-size: 18px;
    color: #333333;
  }
}
.main-container {
  background-color: #f5f5f5;
}
.test::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  filter: blur(20px);
  margin: -30px;
}
.view-list-wrapper {
  padding: 12px;
  // background: url('../assets/bg.jpg');
  // background-size: cover;
  // background-position: center;
  // background-repeat: no-repeat;
  .list-one {
    background-color: rgba(255, 255, 255, 0.9);
    display: flex;
    margin-top: 12px;
    border-radius: 4px;
    height: 60px;
    line-height: 60px;
    box-shadow: 0px 0px 5px #f5f6f7;
    .list-title {
      flex: 1;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      font-size: 16px;
      color: #333333;
      padding-left: 12px;
      text-align: left;
    }
    // .list-btn {
    //   flex: 4;
    //   padding-right: 12px;
    //   text-align: right;
    // }
  }
  .list-one:first-child {
    margin-top: 0px;
  }
}
.page-list {
  display: flex;
  flex-direction: column;
  .header {
    height: 60px;
  }
  .main-container {
    flex: 1;
    min-height: calc(100vh - 60px);
  }
}
</style>
